/** Deck problems reported by the validator, each with the rule it comes from. */

/** Deck sections. */
export type DeckSection = 'legend' | 'champion' | 'main' | 'runes' | 'battlefields' | 'sideboard';

export const DECK_SECTIONS: readonly DeckSection[] = [
  'legend',
  'champion',
  'main',
  'runes',
  'battlefields',
  'sideboard',
];

export type DeckIssueCode =
  | 'unknownCard'
  | 'unknownPrinting'
  | 'legend'
  | 'champion'
  | 'mainSize'
  | 'cardType'
  | 'domain'
  | 'copies'
  | 'unique'
  | 'signatureCount'
  | 'signatureTag'
  | 'runeCount'
  | 'runeType'
  | 'runeDomain'
  | 'battlefieldCount'
  | 'battlefieldType'
  | 'battlefieldDuplicate'
  | 'sideboardSize'
  | 'banned'
  | 'notLegal'
  | 'quantity'
  | 'format';

/** One deck problem, with the rule it breaks. */
export interface DeckIssue {
  code: DeckIssueCode;
  /** Human-readable, with card names. */
  message: string;
  /** The rule it enforces (`CR 103.3.b`, `TR 402.1`). */
  rule: string;
  cardId: string | null;
  section: DeckSection | null;
}

/** Builds a `DeckIssue`. */
export function issue(
  code: DeckIssueCode,
  rule: string,
  message: string,
  cardId: string | null = null,
  section: DeckSection | null = null,
): DeckIssue {
  return { code, rule, message, cardId, section };
}
